// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PillIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.053 4.95a6.658 6.658 0 0 0-9.415 0L4.95 17.636a6.658 6.658 0 0 0 9.415 9.414l12.689-12.686a6.664 6.664 0 0 0-.001-9.414ZM12.95 25.636a4.657 4.657 0 1 1-6.587-6.586L12 13.414 18.588 20l-5.637 5.636ZM25.64 12.95 20 18.586 13.415 12l5.638-5.636a4.657 4.657 0 0 1 6.586 6.586Zm-1.929-2.657a1 1 0 0 1 0 1.415l-3 3a1 1 0 0 1-1.414-1.415l3-3a1 1 0 0 1 1.414 0Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
